import { normalizeCEP } from "@/utils/cepUtils";

/** Brazilian CEP display: `99999-999` (up to 8 digits). No DOM refs / findDOMNode. */
export function formatCepForInput(value: string): string {
  const digits = normalizeCEP(value).slice(0, 8);
  if (digits.length <= 5) {
    return digits;
  }
  return `${digits.slice(0, 5)}-${digits.slice(5)}`;
}

/** CPF display: `999.999.999-99` (up to 11 digits). */
export function formatCpfForInput(value: string): string {
  const digits = value.replace(/\D/g, "").slice(0, 11);
  const len = digits.length;
  if (len <= 3) return digits;
  if (len <= 6) return `${digits.slice(0, 3)}.${digits.slice(3)}`;
  if (len <= 9) {
    return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6)}`;
  }
  return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6, 9)}-${digits.slice(9)}`;
}

/** CPF (`999.999.999-99`) ou CNPJ (`99.999.999/9999-99`) enquanto digita: até 11 dígitos é CPF, acima disso vira CNPJ. */
export function formatCpfCnpjForInput(value: string): string {
  const digits = String(value ?? "").replace(/\D/g, "").slice(0, 14);
  if (digits.length <= 11) return formatCpfForInput(digits);
  const parts = [digits.slice(0, 2), digits.slice(2, 5), digits.slice(5, 8), digits.slice(8, 12), digits.slice(12)];
  return `${parts[0]}.${parts[1]}.${parts[2]}/${parts[3]}${parts[4] ? `-${parts[4]}` : ""}`;
}
